/* tslint:disable:max-line-length */
import * as React from 'react';

import './Loader.scss';

interface ILoaderProps {
    isLoading?: boolean;
}

export const Loader: React.FC<ILoaderProps> = (props) => {
    if (!props.isLoading) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <>{props.children}</>;
    }

    return (
        <div className="Loader" data-testid="loader">
            <div className="Loader-wrapper">
                <div className="Loader-circles" />
            </div>
        </div>
    );
};
